(() => {
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format((Number(cents) || 0) / 100);

  class NuvomiProduct {
    constructor(root) {
      this.root = root;
      this.dataNode = root.querySelector('[data-product-json]');
      if (!this.dataNode) return;
      try {
        this.product = JSON.parse(this.dataNode.textContent);
      } catch (error) {
        return;
      }
      this.selects = [...root.querySelectorAll('[data-option-select]')];
      this.master = root.querySelector('[data-master-select]');
      this.price = root.querySelector('[data-price]');
      this.compare = root.querySelector('[data-compare-price]');
      this.status = root.querySelector('[data-variant-status]');
      this.button = root.querySelector('[data-add-button]');
      this.quantity = root.querySelector('[data-product-quantity]');
      this.galleryThumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      this.galleryMedia = [...root.querySelectorAll('[data-gallery-media]')];
      this.values = this.selects.map(select => select.value);
      this.bind();
      this.update();
    }

    bind() {
      this.root.querySelectorAll('[data-option-value]').forEach(button => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.optionIndex);
          const value = button.dataset.optionValue;
          const select = this.selects[index];
          if (!select || ![...select.options].some(option => option.value === value)) return;
          select.value = value;
          this.values[index] = value;
          this.update();
        });
      });

      this.selects.forEach((select, index) => {
        select.addEventListener('change', () => {
          this.values[index] = select.value;
          this.update();
        });
      });

      this.galleryThumbs.forEach(thumb => {
        thumb.addEventListener('click', () => this.showMedia(thumb.dataset.galleryTarget));
      });

      this.root.querySelectorAll('[data-bundle-quantity]').forEach(option => {
        option.addEventListener('click', () => {
          const quantity = Number(option.dataset.bundleQuantity) || 1;
          if (this.quantity) this.quantity.value = quantity;
          this.root.querySelectorAll('[data-bundle-quantity]').forEach(item => {
            const active = item === option;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });
    }

    showMedia(id) {
      const target = this.galleryMedia.find(media => String(media.dataset.galleryMedia) === String(id));
      if (!target) return;
      this.galleryMedia.forEach(media => {
        const isActive = media === target;
        media.classList.toggle('is-active', isActive);
        media.hidden = !isActive;
      });
      this.galleryThumbs.forEach(thumb => {
        const isActive = String(thumb.dataset.galleryTarget) === String(id);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    update() {
      const variant = this.product.variants.find(item =>
        item.options.every((option, index) => option === this.values[index])
      );
      this.root.querySelectorAll('[data-option-value]').forEach(button => {
        const selected = Number(button.dataset.optionIndex) === this.values.findIndex((value, index) => index === Number(button.dataset.optionIndex) && value === button.dataset.optionValue);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (!variant) return;
      if (this.master) this.master.value = variant.id;
      if (this.price) this.price.textContent = money(variant.price);
      const onePrice = this.root.querySelector('[data-bundle-one-price]');
      const twoCompare = this.root.querySelector('[data-bundle-two-compare]');
      const twoPrice = this.root.querySelector('[data-bundle-two-price]');
      const bundlePicker = this.root.querySelector('[data-bundle-picker]');
      if (onePrice) onePrice.textContent = money(variant.price);
      if (twoCompare) twoCompare.textContent = money(variant.price * 2);
      if (twoPrice) {
        const discount = Number(bundlePicker?.dataset.bundleDiscount) || 0;
        twoPrice.textContent = money(Math.round(variant.price * 2 * (100 - discount) / 100));
      }
      if (this.compare) {
        const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.compare.textContent = showCompare ? money(variant.compare_at_price) : '';
        this.compare.hidden = !showCompare;
      }
      if (this.button) {
        this.button.disabled = !variant.available;
        this.button.textContent = variant.available ? 'Add to cart — free shipping' : 'Sold out';
      }
      if (this.status) this.status.textContent = variant.available ? 'In stock · ships free' : 'This selection is currently unavailable';
      if (variant.featured_media) {
        this.showMedia(variant.featured_media.id);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-nuvomi-product]').forEach(root => new NuvomiProduct(root));
    document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => trigger.parentElement.toggleAttribute('open'));
    });
    const protection = document.querySelector('[data-protection-toggle]');
    if (protection) protection.addEventListener('change', async () => {
      protection.disabled = true;
      try {
        if (protection.checked) {
          await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(protection.dataset.variantId), quantity:1}]})});
        } else {
          await fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:String(protection.dataset.variantId), quantity:0})});
        }
        window.location.reload();
      } catch (error) {
        protection.checked = !protection.checked;
        protection.disabled = false;
      }
    });
  });
})();
